import { Link } from "react-router-dom";
import { hotArticles } from "@/mocks/articles";

export default function CtaSection() {
  const first = hotArticles[0];
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 pb-16 md:px-6 md:pb-24">
        <div className="relative overflow-hidden rounded-2xl bg-foreground-950 px-6 py-12 md:px-12 md:py-16">
          {/* 暖色渐变装饰 */}
          <div aria-hidden className="pointer-events-none absolute -right-16 -top-20 h-72 w-72 rounded-full bg-primary-500/30 blur-3xl" />
          <div aria-hidden className="pointer-events-none absolute -bottom-24 -left-10 h-72 w-72 rounded-full bg-accent-500/25 blur-3xl" />
          <div
            aria-hidden
            className="pointer-events-none absolute right-6 top-2 select-none font-heading text-[10rem] font-black leading-none text-background-50/5 md:text-[16rem]"
          >
            看
          </div>

          <div className="relative max-w-3xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-flashlight-fill" />
              现在就看
            </span>
            <h2 className="mt-5 font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
              让看料，替你把今天最值得看的内容先筛一遍
            </h2>
            <p className="mt-4 text-sm leading-7 text-background-50/75 md:text-base">
              热门推荐实时更新，编辑精选按日重排。不管你是通勤路上想看点干货，
              还是睡前想找点轻松灵感，打开看料，好料都不会错过。
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="#picks"
                className="inline-flex h-11 items-center gap-2 rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400 whitespace-nowrap"
              >
                <i className="ri-arrow-down-line" />
                立即看今日精选
              </a>
              <Link
                to="/rank"
                className="inline-flex h-11 items-center gap-2 rounded-md bg-background-50/10 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/20 whitespace-nowrap"
              >
                <i className="ri-fire-fill text-accent-500" />
                逛逛热门榜单
              </Link>
            </div>
            {first && (
              <p className="mt-6 flex items-center gap-2 text-xs text-background-50/60">
                <i className="ri-arrow-right-line text-accent-500" />
                今日热度最高：「{first.title}」
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}